import { render, staticRenderFns } from "./CustomerDetailForm.vue?vue&type=template&id=08d43d13"
import script from "./CustomerDetailForm.vue?vue&type=script&lang=js"
export * from "./CustomerDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports